<div class="form-sidenav-container">
  <mat-sidenav-container class="form-sections-container">
    <mat-sidenav #sidenav mode="side" [opened]="!isMobileDeviceSize" class="form-sections-sidenav">
      <app-form-left-nav></app-form-left-nav>
    </mat-sidenav>
    <mat-sidenav-content class="form-sections-content" [ngClass]="isMobileDeviceSize ? 'form-sections-content__mobile' : 'form-sections-content__full'" id="form-side-nav-content">
      <app-form-section-select [formType]="formType" class="full-width"></app-form-section-select>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>